const constraints = {
  accident_vehicle: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.accident', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.vehicle', option: 1 }
  ],
  accident_driver: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.accident', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.driver', option: 1 }
  ],
  accident_state: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.accident', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.status', option: 1 },
    { message: 'message.accident', option: 1 }
  ],
  accident_insurance_company: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.accident', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.insuranceCompany', option: 1 }
  ],
  asset_type: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.asset', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.type', option: 1 },
    { message: 'message.asset', option: 1 }
  ],
  driver_company: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.driver', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.society', option: 1 }
  ],
  driver_license_type: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.driver', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.drivingLicense', option: 1 }
  ],
  fleet_vehicle: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.fleet', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.vehicle', option: 1 }
  ],
  operation_vehicle: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.operation', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.vehicle', option: 1 }
  ],
  operation_type: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.operation', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.type', option: 1 },
    { message: 'message.operation', option: 1 }
  ],
  operation_type_notification_recipient: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.operation', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.recipient', option: 1 }
  ],
  operation_type_reminder_recipient: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.operation', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.recipient', option: 1 }
  ],
  service_type_notification_recipient: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.type', option: 1 },
    { message: 'message.service', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.recipient', option: 1 }
  ],
  service_type_reminder_recipient: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.type', option: 1 },
    { message: 'message.service', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.recipient', option: 1 }
  ],
  scheduling_reminder_recipient: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.reminder', option: 1 },
    { message: 'message.scheduled', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.recipient', option: 1 }
  ],
  scheduling_notification_recipient: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.reminder', option: 1 },
    { message: 'message.scheduled', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.recipient', option: 1 }
  ],
  tracker_contract: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.obu', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.contract', option: 1 }
  ],
  vehicle_company: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.vehicle', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.company', option: 1 }
  ],
  vehicle_state: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.vehicle', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.status', option: 1 },
    { message: 'message.vehicle', option: 1 }
  ],
  vehicle_activity_sector: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.vehicle', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.sector', option: 1 },
    { message: 'message.activity', option: 1 }
  ],
  vehicle_classification: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.vehicle', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.type', option: 1 },
    { message: 'message.vehicle', option: 1 }
  ],
  vehicle_fuel_type: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.vehicle', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.type', option: 1 },
    { message: 'message.refueling', option: 1 }
  ],
  vehicle_equipment: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.vehicle', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.vehicleSetUp', option: 1 }
  ],
  vehicle_insurance_company: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.vehicle', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.insuranceCompany', option: 1 }
  ],
  vehicle_owner: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.vehicle', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.owner', option: 1 }
  ],
  vehicle_service_type: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.vehicle', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.type', option: 1 },
    { message: 'message.service', option: 1 }
  ],
  vehicle_registry_code: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.vehicle', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.code', option: 1 },
    { message: 'message.albo2', option: 1 }
  ],
  user_fleet: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.user', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.fleet', option: 1 }
  ],
  user_type: [
    { message: 'warnings.association', option: 1 },
    { message: 'message.user', option: 1 },
    { message: 'message.and', option: 1 },
    { message: 'message.type', option: 1 },
    { message: 'message.user', option: 1 }
  ]
}

export default constraints
